import { Input } from '@/components/ui/Input';
import { Search, X } from 'lucide-react';
import { useEffect, useState } from 'react';

interface SearchInputProps {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  debounceMs?: number;
}

export function SearchInput({ value: externalValue, onChange, placeholder = 'Rechercher...', debounceMs = 300 }: SearchInputProps) {
  const [value, setValue] = useState(externalValue || '');

  useEffect(() => {
    if (externalValue !== undefined) setValue(externalValue);
  }, [externalValue]);

  useEffect(() => {
    const timer = setTimeout(() => onChange(value), debounceMs);
    return () => clearTimeout(timer);
  }, [value, debounceMs, onChange]);

  return (
    <div className="relative">
      <Input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        icon={<Search className="h-4 w-4" />}
        className="bg-neutral-100 border-neutral-200 dark:bg-neutral-800 dark:border-neutral-700"
      />
      {value && (
        <button
          onClick={() => setValue('')}
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded-lg p-1 text-neutral-400 transition-all duration-200 hover:bg-neutral-200 hover:text-neutral-600 dark:text-neutral-500 dark:hover:bg-neutral-700 dark:hover:text-neutral-300"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}
